import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';
import R from 'ramda';

import ScheduleBox from '../ScheduleBox';
import styles from './schedule.css';

const { div, header, h1 } = hh(h);

const Schedule = ({
    schedules
}) => {
    const createSchedule = (schedule) => (
        div({className: styles.scheduleContainer}, [
            header({className: styles.scheduleHeader}, [
                h1({className: styles.scheduleTitle}, schedule.title)]),
            R.addIndex(R.map)(
                (item, index) => (h(ScheduleBox, R.assoc('key', index, item))),
                schedule.schedule)])
    );

    return div({className: styles.schedulesContainer}, R.map(createSchedule, schedules));
};

Schedule.propTypes = {
    schedules: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            schedule: PropTypes.arrayOf(
                PropTypes.shape({
                    startTime: PropTypes.string.isRequired,
                    endTime: PropTypes.string.isRequired,
                    bodyText: PropTypes.string.isRequired
                })
            )
        })
    ).isRequired
};

export default Schedule;



/** WEBPACK FOOTER **
 ** ./src/Schedule/index.js
 **/